<template>
    <el-dialog title="商品退货" :visible.sync="dialogVisible" :width="dialogWidth" :top="dialogTop" @open="onDialogOpen" @close="onDialogClose" append-to-body @keydown.native="handleGlobalKeyDown"
               :class="['return-dialog', { 'mobile-dialog': isMobile }]">
        <div @keydown="handleGlobalKeyDown" @keyup.stop @keypress.stop tabindex="0" class="dialog-content-wrapper">
            <!-- 主要操作区域 -->
            <div class="main-operation-area">
                <!-- 原单号查询区域 -->
                <div class="search-section">
                    <el-form inline size="small" class="search-form" @submit.native.prevent>
                        <el-form-item label="原单号" class="search-item">
                            <el-input ref="originalOrderInput" v-model="originalOrderNo" placeholder="请输入原单号按回车查询" style="width: 250px" @keydown.enter.native.prevent="handleOrderSearchOrShowDialog" />
                        </el-form-item>
                        <el-form-item class="search-item">
                            <span v-if="!isMobile" class="operation-hints">
                                <span class="hint-title">快捷键说明:</span>
                                <span class="hint-item">↑↓ - 选择商品</span>
                                <span class="hint-item">Tab - 切换焦点</span>
                                <span class="hint-item">Del - 删除选中</span>
                                <span class="hint-item">F2 - 确认退货</span>
                                <span class="hint-item">Esc - 关闭弹窗</span>
                            </span>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 原单信息显示 -->
                <div v-if="orderInfo" class="order-info-section">
                    <div class="info-header">
                        <span class="info-title">原单信息</span>
                        <div class="info-content">
                            <span class="info-item">单号: {{ orderInfo.orderNo }}</span>
                            <span class="info-item">日期: {{ orderInfo.orderDate }}</span>
                            <span class="info-item">收银员: {{ orderInfo.cashier }}</span>
                            <span class="info-item">总金额: ¥{{ orderInfo.totalAmount }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 响应式布局：商品列表 + 操作区域 -->
            <div v-if="orderInfo" class="content-layout" :class="{ 'mobile-layout': isMobile }">
                <!-- 商品列表区域 -->
                <div class="products-panel">
                    <div class="panel-header">
                        <span class="panel-title">原单商品列表</span>
                        <span v-if="!isMobile" class="panel-hint">↑↓选择商品 Enter确认 [{{ selectedOriginalProductIndex + 1 }}/{{originalProducts.length }}]</span>
                    </div>
                    <el-table ref="originalProductTable" :data="originalProducts" border :height="tableHeight" @row-click="onOriginalProductClick" highlight-current-row :row-class-name="getOriginalProductRowClassName"
                              @keydown.native="handleProductTableKeyDown" tabindex="0">
                        <el-table-column prop="bgmName" label="商品名称" :min-width="isMobile ? 120 : 180" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.bgmName }}</span>
                                <el-tag v-if="scope.row.isZp" type="success" size="mini" style="margin-left: 5px;">赠品</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="!isMobile" prop="spec" label="规格" width="120" show-overflow-tooltip />
                        <el-table-column prop="purchaseQuantity" label="数量" :width="isMobile ? 60 : 80" align="center" />
                        <el-table-column prop="ableNum" label="可退数量" :width="isMobile ? 60 : 80" align="center" />
                        <el-table-column prop="price" label="单价" :width="isMobile ? 70 : 80" align="right" />
                        <el-table-column v-if="!isMobile" label="小计" width="80" align="right">
                            <template slot-scope="scope">
                                <span>{{ (scope.row.purchaseQuantity * scope.row.price).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="!isMobile" prop="batchno" label="批号" width="100" show-overflow-tooltip />
                    </el-table>
                </div>

                <!-- 操作区域 -->
                <div class="operations-panel">
                    <!-- 选中商品信息 -->
                    <div v-if="selectedOriginalProduct" class="selected-product-info" :class="{ 'mobile-info': isMobile }">
                        <div class="panel-header">
                            <span class="panel-title">选中商品</span>
                        </div>
                        <div class="product-details" :class="{ 'mobile-details': isMobile }">
                            <div class="detail-item">
                                <span class="detail-label">商品:</span>
                                <span class="detail-value">{{ selectedOriginalProduct.bgmName }}</span>
                            </div>
                            <div v-if="!isMobile" class="detail-item">
                                <span class="detail-label">规格:</span>
                                <span class="detail-value">{{ selectedOriginalProduct.spec || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">数量:</span>
                                <span class="detail-value">{{ selectedOriginalProduct.purchaseQuantity }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">单价:</span>
                                <span class="detail-value">¥{{ selectedOriginalProduct.price }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 退货数量输入 -->
                    <div v-if="selectedOriginalProduct" class="quantity-input-section" :class="{ 'mobile-quantity': isMobile }">
                        <div class="panel-header">
                            <span class="panel-title">退货操作</span>
                        </div>
                        <div class="quantity-form" :class="{ 'mobile-form': isMobile }">
                            <div class="form-row" :class="{ 'mobile-row': isMobile }">
                                <label class="form-label">数量:</label>
                                <!--  @keydown.enter.native.prevent="addToReturnCart" -->
                                <el-input ref="returnQuantityInput" v-model="returnQuantity" placeholder="数量" :style="{ width: isMobile ? '80px' : '100px' }" type="number" :min="1" :max="selectedOriginalProduct.ableNum"
                                          @keydown.native="handleQuantityKeyDown" size="small" />
                                <span class="max-hint">最大: {{ selectedOriginalProduct.ableNum }}</span>
                            </div>
                            <div class="form-actions">
                                <el-button type="success" :size="isMobile ? 'mini' : 'small'" @click="addToReturnCart" :disabled="!returnQuantity || returnQuantity <= 0">
                                    {{ isMobile ? '添加' : '添加 [Enter]' }}
                                </el-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- 退货商品清单 -->
            <div class="return-cart-section" :class="{ 'mobile-cart': isMobile }">
                <div class="cart-header" :class="{ 'mobile-header': isMobile }">
                    <div class="cart-title-area">
                        <span class="cart-title">退货清单</span>
                        <span class="cart-count">[{{ returnCartItems.length }}种]</span>
                        <span v-if="!isMobile && returnCartItems.length > 0" class="cart-hint">
                            ↑↓选择 Del删除 [{{ selectedCartIndex + 1 }}/{{ returnCartItems.length }}]
                        </span>
                    </div>
                    <div class="cart-summary" :class="{ 'mobile-summary': isMobile }">
                        <span class="summary-item">{{ totalReturnQuantity }}件</span>
                        <span class="summary-item">¥{{ totalReturnAmount.toFixed(2) }}</span>
                    </div>
                </div>
                <el-table ref="returnCartTable" :data="returnCartItems" border :height="cartTableHeight" @row-click="onCartItemClick" @keydown.native="handleCartTableKeyDown" highlight-current-row
                          :row-class-name="getCartItemRowClassName" tabindex="0">
                    <el-table-column prop="bgmName" label="商品名称" :min-width="isMobile ? 100 : 180" show-overflow-tooltip />
                    <el-table-column v-if="!isMobile" prop="spec" label="规格" width="100" show-overflow-tooltip />
                    <el-table-column prop="returnQuantity" label="数量" :width="isMobile ? 50 : 80" align="center" />
                    <el-table-column prop="price" label="单价" :width="isMobile ? 60 : 80" align="right" />
                    <el-table-column v-if="!isMobile" label="小计" width="80" align="right">
                        <template slot-scope="scope">
                            <span class="amount">{{ (scope.row.returnQuantity * scope.row.price).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" :width="isMobile ? 50 : 60" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" :size="isMobile ? 'mini' : 'small'" @click="removeFromReturnCart(scope.$index)" class="delete-btn">
                                {{ isMobile ? '删' : '删除' }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div slot="footer" class="dialog-footer" :class="{ 'mobile-footer': isMobile }">
                <div v-if="!isMobile" class="footer-summary">
                    <span v-if="returnCartItems.length > 0" class="footer-info">
                        共选择 <strong>{{ returnCartItems.length }}</strong> 种商品，
                        退货 <strong>{{ totalReturnQuantity }}</strong> 件，
                        金额 <strong class="amount">¥{{ totalReturnAmount.toFixed(2) }}</strong>
                    </span>
                </div>
                <div class="footer-buttons" :class="{ 'mobile-buttons': isMobile }">
                    <!-- <el-button @click="handleCancel" :size="isMobile ? 'small' : 'small'">
          {{ isMobile ? '取消' : '取消 [Esc]' }}
        </el-button> -->
                    <el-button type="primary" @click="confirmReturn" :disabled="returnCartItems.length === 0" :size="isMobile ? 'small' : 'small'">
                        {{ isMobile ? '确认退货' : '确认退货 [Ctrl+Enter]' }}
                    </el-button>
                </div>
            </div>

            <!-- 原单选择弹窗 -->
            <el-dialog title="选择原单" :visible.sync="orderSelectDialogVisible" width="60%" append-to-body>
                <el-table :data="orderSearchResults" border height="300px" @row-dblclick="onOrderSelect" @row-click="onOrderRowClick" highlight-current-row :row-class-name="getOrderRowClassName">
                    <el-table-column prop="retailId" label="单号" width="150" />
                    <el-table-column label="日期" width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.saledate ? new Date(scope.row.saledate).toLocaleDateString() : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cashierName" label="收银员" width="100" />
                    <el-table-column prop="totalMoney" label="总金额" width="100" />
                    <el-table-column prop="customerName" label="会员" width="120" />
                    <el-table-column label="状态" width="80">
                        <template slot-scope="scope">
                            <span>{{ getOrderStatusText(scope.row.state) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="orderSelectDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmOrderSelect" :disabled="!selectedOrder">确认</el-button>
                </span>
            </el-dialog>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ReturnDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        storeId: {
            type: Number,
            default: ''
        },
        curDate: {
            type: Number,
            default: ''
        },
        curTime: {
            type: Number,
            default: ''
        },
        day: {
            type: Number,
            default: ''
        },
        week: {
            type: Number,
            default: ''
        }
    },
    data() {
        return {
            originalOrderNo: '', // 原单号
            orderInfo: null, // 原单信息
            originalProducts: [], // 原单商品列表
            selectedOriginalProduct: null, // 选中的原单商品
            selectedOriginalProductIndex: -1, // 选中的原单商品索引
            returnQuantity: 1, // 退货数量
            returnCartItems: [], // 退货商品清单
            // 原单选择弹窗相关
            orderSelectDialogVisible: false, // 原单选择弹窗显示状态
            orderSearchResults: [], // 原单搜索结果
            selectedOrder: null, // 选中的原单
            selectedOrderIndex: -1, // 选中的原单索引
            // 界面状态
            searching: false, // 搜索状态
            currentFocus: 'search', // 当前焦点位置: search, product, quantity, cart
            // 退货清单选择
            selectedCartItem: null, // 选中的退货清单商品
            selectedCartIndex: -1,// 选中的退货清单商品索引
            orderList: [], // 原单商品列表
            payList: [],//支付账簿信息
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            }
        },
        // 退货商品总件数
        totalReturnQuantity() {
            return this.returnCartItems.reduce((total, item) => total + item.returnQuantity, 0)
        },
        // 退货商品总金额
        totalReturnAmount() {
            return this.returnCartItems.reduce((total, item) => total + (item.returnQuantity * item.price), 0)
        },
        // 响应式相关计算属性
        isMobile() {
            return window.innerWidth <= 768
        },
        dialogWidth() {
            if (window.innerWidth <= 480) {
                return '95%'
            } else if (window.innerWidth <= 768) {
                return '90%'
            } else if (window.innerWidth <= 1024) {
                return '85%'
            } else {
                return '80%'
            }
        },
        dialogTop() {
            return window.innerWidth <= 768 ? '2vh' : '5vh'
        },
        tableHeight() {
            if (window.innerWidth <= 480) {
                return '200px'
            } else if (window.innerWidth <= 768) {
                return '240px'
            } else {
                return '280px'
            }
        },
        cartTableHeight() {
            if (window.innerWidth <= 480) {
                return '100px'
            } else if (window.innerWidth <= 768) {
                return '110px'
            } else {
                return '120px'
            }
        }
    },

    methods: {
        // 弹窗打开时的处理
        onDialogOpen() {
            this.currentFocus = 'search'
            this.$nextTick(() => {
                // 设置焦点到包装器以接收键盘事件
                const wrapper = this.$el.querySelector('.dialog-content-wrapper')
                if (wrapper) {
                    wrapper.focus()
                }

                if (this.$refs.originalOrderInput) {
                    this.$refs.originalOrderInput.focus()
                }
            })
            this.$emit('opened')
        },

        // 弹窗关闭时的处理
        onDialogClose() {
            this.resetData()
            this.$emit('close')
        },

        // 重置数据
        resetData() {
            this.originalOrderNo = ''
            this.orderInfo = null
            this.originalProducts = []
            this.selectedOriginalProduct = null
            this.selectedOriginalProductIndex = -1
            this.returnQuantity = 1
            this.returnCartItems = []
            // 重置原单选择弹窗相关数据
            this.orderSelectDialogVisible = false
            this.orderSearchResults = []
            this.selectedOrder = null
            this.selectedOrderIndex = -1
            // 重置界面状态
            this.searching = false
            this.currentFocus = 'search'
            // 重置退货清单选择
            this.selectedCartItem = null
            this.selectedCartIndex = -1
        },

        // 全局键盘事件处理
        handleGlobalKeyDown(event) {
            console.log(event, 'event33333');

            // 检查事件目标是否是输入框
            const isInputElement = event.target.tagName === 'INPUT' ||
                event.target.tagName === 'TEXTAREA' ||
                event.target.contentEditable === 'true'

            // F2 确认退货（安全的快捷键，不容易误触）
            if (event.key === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation(); // 阻止事件冒泡到全局处理器
                if (this.returnCartItems.length > 0) {
                    this.confirmReturn()
                } else {
                    this.$message.warning('请先添加要退货的商品')
                }
                return
            }

            // Esc 关闭弹窗
            if (event.key === 'Escape') {
                event.preventDefault()
                this.handleCancel()
                return
            }

            // Tab 切换焦点
            if (event.key === 'Tab') {
                event.preventDefault()
                this.switchFocus(event.shiftKey)
                return
            }

            // 如果是输入框，只阻止特定的快捷键，允许正常输入
            if (isInputElement) {
                // 在输入框中，只阻止可能冲突的功能键
                if (event.key.startsWith('F') && event.key !== 'F2') {
                    event.preventDefault()
                }
                // 允许正常的输入操作（字符、数字、退格、删除等）
                return
            }

            // 非输入框元素，阻止可能触发外层快捷键的按键
            if (event.key.length === 1 ||
                event.key === 'Enter' ||
                event.key === 'Backspace' ||
                event.key === 'Delete' ||
                event.key.startsWith('Arrow') ||
                event.key.startsWith('F')) {
                event.preventDefault()
            }
        },

        // 切换焦点
        switchFocus(reverse = false) {
            const focusOrder = ['search', 'product', 'quantity', 'cart']
            let currentIndex = focusOrder.indexOf(this.currentFocus)

            if (reverse) {
                currentIndex = currentIndex <= 0 ? focusOrder.length - 1 : currentIndex - 1
            } else {
                currentIndex = currentIndex >= focusOrder.length - 1 ? 0 : currentIndex + 1
            }

            this.currentFocus = focusOrder[currentIndex]
            this.setFocusToCurrentElement()
        },

        // 设置焦点到当前元素
        setFocusToCurrentElement() {
            this.$nextTick(() => {
                switch (this.currentFocus) {
                    case 'search':
                        if (this.$refs.originalOrderInput) {
                            this.$refs.originalOrderInput.focus()
                        }
                        break
                    case 'product':
                        if (this.$refs.originalProductTable && this.originalProducts.length > 0) {
                            this.$refs.originalProductTable.$el.focus()
                            if (this.selectedOriginalProductIndex === -1 && this.originalProducts.length > 0) {
                                this.selectedOriginalProductIndex = 0
                                this.selectedOriginalProduct = { ...this.originalProducts[0] }
                                this.returnQuantity = this.selectedOriginalProduct.ableNum
                            }
                        }
                        break
                    case 'quantity':
                        if (this.$refs.returnQuantityInput && this.selectedOriginalProduct) {
                            this.$refs.returnQuantityInput.focus()
                        }
                        break
                    case 'cart':
                        if (this.$refs.returnCartTable && this.returnCartItems.length > 0) {
                            this.$refs.returnCartTable.$el.focus()
                            // 如果没有选中任何商品，自动选择第一个
                            if (this.selectedCartIndex === -1 && this.returnCartItems.length > 0) {
                                this.selectedCartIndex = 0
                                this.selectedCartItem = { ...this.returnCartItems[0] }
                                this.scrollToSelectedCartItem()
                            }
                        }
                        break
                }
            })
        },



        // 商品表格键盘事件
        handleProductTableKeyDown(event) {
            event.stopPropagation() // 阻止事件冒泡

            if (event.key === 'ArrowUp') {
                event.preventDefault()
                if (this.selectedOriginalProductIndex > 0) {
                    this.selectedOriginalProductIndex--
                    this.selectedOriginalProduct = { ...this.originalProducts[this.selectedOriginalProductIndex] }
                    this.returnQuantity = this.selectedOriginalProduct.ableNum
                    this.scrollToSelectedProduct()
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault()
                if (this.selectedOriginalProductIndex < this.originalProducts.length - 1) {
                    this.selectedOriginalProductIndex++
                    this.selectedOriginalProduct = { ...this.originalProducts[this.selectedOriginalProductIndex] }
                    this.returnQuantity = this.selectedOriginalProduct.ableNum
                    this.scrollToSelectedProduct()
                }
            } else if (event.key === 'Enter' && event.ctrlKey) {
                event.preventDefault()
                console.log('退货清单中检测到Ctrl+Enter，执行确认退货');
                // 执行确认退货
                if (this.returnCartItems.length > 0) {
                    this.confirmReturn();
                } else {
                    this.$message.warning('请先添加要退货的商品');
                }
                return
            } else if (event.key === 'Enter') {
                event.preventDefault()
                if (this.selectedOriginalProduct) {
                    this.currentFocus = 'quantity'
                    this.setFocusToCurrentElement()
                }
            } else if (event.key === 'Escape') {
                event.preventDefault()
                this.handleCancel()
                return
            }

        },

        // 数量输入框键盘事件
        handleQuantityKeyDown(event) {
            event.stopPropagation() // 阻止事件冒泡

            if (event.key === 'ArrowUp') {
                event.preventDefault()
                this.currentFocus = 'product'
                this.setFocusToCurrentElement()
            } else if (event.key === 'Enter' && event.ctrlKey) {
                event.preventDefault()
                console.log('退货清单中检测到Ctrl+Enter，执行确认退货');
                // 执行确认退货
                if (this.returnCartItems.length > 0) {
                    this.confirmReturn();
                } else {
                    this.$message.warning('请先添加要退货的商品');
                }
                return
            }else if (event.key === 'Enter') {
                event.preventDefault()
                this.addToReturnCart()
                return
            } else if (event.key === 'ArrowDown' && this.returnCartItems.length > 0) {
                event.preventDefault()
                this.currentFocus = 'cart'
                this.setFocusToCurrentElement()
            } else if (event.key === 'Escape') {
                event.preventDefault()
                this.handleCancel()
                return
            }
        },

        // 购物车表格键盘事件
        handleCartTableKeyDown(event) {
            event.stopPropagation() // 阻止事件冒泡
            console.log(event, 'event');

            if (event.key === 'ArrowUp') {
                event.preventDefault()
                if (this.selectedCartIndex > 0) {
                    this.selectedCartIndex--
                    this.selectedCartItem = { ...this.returnCartItems[this.selectedCartIndex] }
                    this.scrollToSelectedCartItem()
                } else {
                    // 如果已经是第一个，切换到数量输入
                    this.currentFocus = 'quantity'
                    this.setFocusToCurrentElement()
                }
            } else if (event.key === 'Enter' && event.ctrlKey) {
                event.preventDefault()
                console.log('退货清单中检测到Ctrl+Enter，执行确认退货');
                // 执行确认退货
                if (this.returnCartItems.length > 0) {
                    this.confirmReturn();
                } else {
                    this.$message.warning('请先添加要退货的商品');
                }
                return
            }
            else if (event.key === 'ArrowDown') {
                event.preventDefault()
                if (this.selectedCartIndex < this.returnCartItems.length - 1) {
                    this.selectedCartIndex++
                    this.selectedCartItem = { ...this.returnCartItems[this.selectedCartIndex] }
                    this.scrollToSelectedCartItem()
                }
            } else if (event.key === 'Delete') {
                event.preventDefault()
                // 删除选中的退货商品
                if (this.selectedCartIndex >= 0 && this.selectedCartIndex < this.returnCartItems.length) {
                    this.removeFromReturnCart(this.selectedCartIndex)
                }
            } else if (event.key === 'Escape') {
                event.preventDefault()
                this.handleCancel()
                return
            }
        },

        // 滚动到选中的商品
        scrollToSelectedProduct() {
            this.$nextTick(() => {
                if (this.$refs.originalProductTable && this.selectedOriginalProductIndex >= 0) {
                    this.$refs.originalProductTable.setCurrentRow(this.originalProducts[this.selectedOriginalProductIndex])
                }
            })
        },

        // 滚动到选中的退货清单商品
        scrollToSelectedCartItem() {
            this.$nextTick(() => {
                if (this.$refs.returnCartTable && this.selectedCartIndex >= 0) {
                    this.$refs.returnCartTable.setCurrentRow(this.returnCartItems[this.selectedCartIndex])
                }
            })
        },

        // 退货清单商品行点击处理
        onCartItemClick(row) {
            this.selectedCartItem = { ...row }
            this.selectedCartIndex = this.returnCartItems.findIndex(item =>
                item.bgmId === row.bgmId && item.batchno === row.batchno
            )
        },

        // 获取退货清单商品行样式类名
        getCartItemRowClassName({ rowIndex }) {
            if (rowIndex === this.selectedCartIndex) {
                return 'selected-return-product-row'
            }
            return ''
        },

        // 处理原单号查询或显示弹窗
        async handleOrderSearchOrShowDialog() {
            if (!this.originalOrderNo || this.originalOrderNo.trim() === '') {
                this.$message.warning('请输入原单号')
                this.$refs.originalOrderInput.focus()
                return
            }

            this.searching = true
            try {
                // 调用查询原单信息的接口
                const res = await this.$http.retailQuery({
                    businessId: "",
                    creater: 0,
                    ormId: 0,
                    page: 1,
                    rows: 1000,
                    start: "",
                    end: "",
                    retailId: this.originalOrderNo,
                })


                if (res && res.status === 200 && res.result && res.result.list) {
                    const orderList = res.result.list
                    this.orderList = orderList
                    console.log(res, 'res');
                    if (orderList.length > 1) {
                        // 多条结果，显示选择弹窗
                        this.orderSearchResults = orderList
                        this.orderSelectDialogVisible = true
                    } else if (orderList.length === 1) {
                        // 只有一条结果，直接显示
                        this.loadOrderData(orderList[0])
                    } else {
                        this.$message.error('未找到该单号的信息或退款完成')
                    }
                } else {
                    this.$message.error('未找到该单号的信息或退款完成')
                }
            } catch (error) {
                console.error('查询原单信息失败:', error)
                this.$message.error('查询原单信息失败，请重试')
            } finally {
                this.searching = false
            }
        },

        // 加载原单数据
        loadOrderData(orderData) {
            // 构建原单信息
            this.orderInfo = {
                orderNo: orderData.retailId || '', // 单号
                orderDate: orderData.createTime ? new Date(orderData.createTime).toLocaleString() : '', // 日期
                cashier: orderData.cashierName || '', // 收银员
                totalAmount: orderData.totalMoney || 0, // 总金额
                memberName: orderData.customerName || '', // 会员姓名
                status: this.getOrderStatusText(orderData.state) // 状态
            }
            this.payList = orderData.payList
            // 构建原单商品列表
            this.originalProducts = (orderData.detailList || []).map(item => ({
                bgmId: item.bgmId,
                bgmName: item.bgmName || `商品${item.bgmId}`, // 商品名称（如果没有则显示商品ID）
                spec: item.spec || '', // 规格
                purchaseQuantity: item.retailPnumber || 0, // 购买数量
                ableNum: item.ableNum || item.retailPnumber || 0, // 可退数量
                retailPrice: item.retailPrice || 0, // 统一零售价
                price: item.psprice || 0, // 统一零售价
                batchno: item.batchno || '', // 批号
                sterBatchno: item.sterBatchno || '', // 灭菌批号
                prodate: item.prodate, // 生产日期
                expidate: item.expidate, // 失效日期
                memPrice: item.memPrice || 0, // 会员价
                psprice: item.psprice || 0, // 促销价
                isZp: item.isZp || 0, // 赠品标识（0:正常商品，1:赠品）
                originId: item.originId, // 原始ID
                retailId: item.retailId, // 零售ID
                rowno: item.rowno, // 行号
                rtgId: item.rtgId || '', // 原单商品ID
                salesPerson: item.salesPerson || '',
            }))
            this.$message.success('原单信息查询成功')

            // 自动选择第一个商品并切换焦点
            if (this.originalProducts.length > 0) {
                this.selectedOriginalProductIndex = 0
                this.selectedOriginalProduct = { ...this.originalProducts[0] }
                this.returnQuantity = this.selectedOriginalProduct.ableNum
                this.currentFocus = 'product'
                this.$nextTick(() => {
                    this.setFocusToCurrentElement()
                })
            }
        },

        // 获取订单状态文本
        getOrderStatusText(state) {
            const statusMap = {
                0: '正常',
                1: '已退货',
                2: '部分退货',
                3: '已取消'
            }
            return statusMap[state] || '未知'
        },



        // 处理原单号查询（原方法保留）
        async handleOrderSearch() {
            if (!this.originalOrderNo || this.originalOrderNo.trim() === '') {
                this.$message.warning('请输入原单号')
                return
            }

            try {
                // 这里调用查询原单信息的接口
                const res = await this.$http.getOriginalOrderInfo({
                    orderNo: this.originalOrderNo,
                    storeId: this.storeId
                })

                if (res && res.status === 200 && res.result) {
                    this.orderInfo = res.result.orderInfo
                    this.originalProducts = res.result.products.map(item => ({
                        ...item,
                        purchaseQuantity: item.quantity, // 购买数量
                        price: item.price || 0 // 统一零售价
                    }))
                    this.$message.success('原单信息查询成功')
                } else {
                    this.orderInfo = null
                    this.originalProducts = []
                    this.$message.error('未找到该单号的信息或退款完成')
                }
            } catch (error) {
                console.error('查询原单信息失败:', error)
                this.$message.error('查询原单信息失败，请重试')
                this.orderInfo = null
                this.originalProducts = []
            }
        },

        // 原单商品行点击处理
        onOriginalProductClick(row) {
            this.selectedOriginalProduct = { ...row }
            this.selectedOriginalProductIndex = this.originalProducts.findIndex(item =>
                item.bgmId === row.bgmId && item.batchno === row.batchno
            )
            this.returnQuantity = this.selectedOriginalProduct.ableNum
        },

        // 获取原单商品行样式类名
        getOriginalProductRowClassName({ rowIndex }) {
            if (rowIndex === this.selectedOriginalProductIndex) {
                return 'selected-return-product-row'
            }
            return ''
        },

        // 添加到退货清单
        addToReturnCart() {
            if (!this.selectedOriginalProduct) {
                this.$message.warning('请先选择要退货的商品')
                return
            }

            const quantity = parseInt(this.returnQuantity) || 1
            if (quantity <= 0) {
                this.$message.warning('退货数量必须大于0')
                return
            }

            if (quantity > this.selectedOriginalProduct.ableNum) {
                this.$message.warning('退货数量不能超过可退数量')
                return
            }

            // 检查是否已经在退货清单中（需要考虑赠品标识和原单商品ID）
            const existingIndex = this.returnCartItems.findIndex(item =>
                item.bgmId === this.selectedOriginalProduct.bgmId &&
                item.batchno === this.selectedOriginalProduct.batchno &&
                item.isZp === this.selectedOriginalProduct.isZp &&
                item.rtgId === this.selectedOriginalProduct.rtgId
            )

            if (existingIndex !== -1) {
                // 如果已存在，累加数量
                const newQuantity = this.returnCartItems[existingIndex].returnQuantity + quantity
                if (newQuantity > this.selectedOriginalProduct.ableNum) {
                    this.$message.warning('退货总数量不能超过可退数量')
                    return
                }
                this.returnCartItems[existingIndex].returnQuantity = newQuantity
            } else {
                // 如果不存在，添加新记录
                this.returnCartItems.push({
                    ...this.selectedOriginalProduct,
                    returnQuantity: quantity
                })
            }

            this.$message.success(`已添加 ${this.selectedOriginalProduct.bgmName} 到退货清单`)
            this.returnQuantity = 1 // 重置数量

            // 自动选中新添加或更新的商品
            const targetIndex = existingIndex !== -1 ? existingIndex : this.returnCartItems.length - 1
            this.selectedCartIndex = targetIndex
            this.selectedCartItem = { ...this.returnCartItems[targetIndex] }
        },

        // 从退货清单中删除
        removeFromReturnCart(index) {
            if (index < 0 || index >= this.returnCartItems.length) {
                return
            }

            const removedItem = this.returnCartItems[index]
            this.returnCartItems.splice(index, 1)
            this.$message.success(`已删除 ${removedItem.bgmName}`)

            // 更新选中索引
            if (this.selectedCartIndex === index) {
                // 如果删除的是当前选中的商品
                if (this.returnCartItems.length === 0) {
                    // 如果清单为空，重置选择
                    this.selectedCartIndex = -1
                    this.selectedCartItem = null
                } else if (index >= this.returnCartItems.length) {
                    // 如果删除的是最后一个，选择前一个
                    this.selectedCartIndex = this.returnCartItems.length - 1
                    this.selectedCartItem = { ...this.returnCartItems[this.selectedCartIndex] }
                } else {
                    // 否则选择当前位置的商品
                    this.selectedCartItem = { ...this.returnCartItems[this.selectedCartIndex] }
                }
            } else if (this.selectedCartIndex > index) {
                // 如果删除的商品在选中商品之前，索引需要减1
                this.selectedCartIndex--
            }

            // 更新表格选中状态
            this.$nextTick(() => {
                if (this.selectedCartIndex >= 0 && this.$refs.returnCartTable) {
                    this.$refs.returnCartTable.setCurrentRow(this.returnCartItems[this.selectedCartIndex])
                }
            })
        },

        // 原单选择弹窗相关方法
        // 原单行点击处理
        onOrderRowClick(row) {
            this.selectedOrder = { ...row }
            this.selectedOrderIndex = this.orderSearchResults.findIndex(item =>
                item.retailId === row.retailId
            )
        },

        // 原单双击选择
        onOrderSelect(row) {
            this.selectedOrder = { ...row }
            this.confirmOrderSelect()
        },

        // 获取原单行样式类名
        getOrderRowClassName({ rowIndex }) {
            if (rowIndex === this.selectedOrderIndex) {
                return 'selected-return-product-row'
            }
            return ''
        },

        // 确认选择原单
        confirmOrderSelect() {
            if (!this.selectedOrder) {
                this.$message.warning('请选择一个原单')
                return
            }

            this.loadOrderData(this.selectedOrder)
            this.orderSelectDialogVisible = false

            // 重置选择状态
            this.selectedOrder = null
            this.selectedOrderIndex = -1
        },

        // 确认退货
        confirmReturn() {
            if (this.returnCartItems.length === 0) {
                this.$message.warning('请先添加要退货的商品')
                return
            }
            console.log(this.returnCartItems, 'returnCartItems');
            // 将退货清单中的商品转换为购物车格式
            const returnItems = this.returnCartItems.map(item => ({
                ...item,
                price: item.retailPrice,
                changePrice: item.price,
                quantity: -item.returnQuantity, // 负数表示退货
                psprice: item.psprice,
                isReturn: true, // 标记为退货商品
                returnReason: '商品退货', // 退货原因
                originalQuantity: item.returnQuantity, // 保存原始退货数量（正数）
                originId: this.originalOrderNo, // 保存原单号
                rtgId: item.rtgId || '', // 原单商品ID
                salesPerson: item.salesPerson || '',
                amount: item.psprice * (-item.returnQuantity),
                actualPrice: item.psprice,
            }))

            // 触发确认事件，传递退货商品列表
            this.$emit('confirm', returnItems, this.originalOrderNo, this.orderList)

            // 关闭弹窗
            this.dialogVisible = false

            this.$message.success(`已添加 ${returnItems.length} 种退货商品到购物车`)
        },

        // 取消操作
        handleCancel() {
            this.dialogVisible = false
        },

        // 处理窗口大小变化
        handleResize() {
            // 强制重新计算响应式属性
            this.$forceUpdate()
        }
    },

    mounted() {
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize)
    },

    beforeDestroy() {
        // 移除窗口大小变化监听器
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped>
/* 弹窗内容包装器 */
.dialog-content-wrapper {
    outline: none;
    width: 100%;
    height: 100%;
}

.dialog-content-wrapper:focus {
    outline: none;
}

/* 主要操作区域 */
.main-operation-area {
    margin-bottom: 5px;
}

/* 搜索区域样式 */
.search-section {
    background: linear-gradient(135deg, #409eff, #66b1ff);
    padding: 12px 16px;
    margin-bottom: 5px;
}

.search-form {
    margin: 0;
}

.search-item {
    margin-right: 15px;
    margin-bottom: 0;
}

.search-button {
    margin-bottom: 0;
}

/* 原单信息区域样式 */
.order-info-area {
    background: #f5f7fa;
    padding: 15px;
    border: 1px solid #e4e7ed;
}

/* 原单商品区域样式 */
.original-products-area {
    margin-bottom: 15px;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
    padding: 8px 12px;
    background: #f0f9ff;
    border-left: 4px solid #409eff;
}

/* 退货数量输入区域样式 */
.return-quantity-area {
    background: #f9f9f9;
    padding: 15px;

    border: 1px solid #e4e7ed;
}

.selected-product-name {
    color: #409eff;
    font-weight: 600;
    padding: 4px 8px;
    background: #ecf5ff;
}

/* 退货清单区域样式 */
.return-cart-area {
    margin-top: 15px;
}

.return-cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: linear-gradient(135deg, #67c23a, #85ce61);

    color: #fff;
}

.cart-title {
    font-size: 16px;
    font-weight: 600;
}

.cart-summary {
    font-size: 14px;
    font-weight: 600;
}

/* 搜索区域内部样式 */
.search-section .el-form-item__label {
    color: #fff !important;
    font-weight: 600;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.search-section .el-input__inner {
    border: 2px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.95);

    transition: all 0.3s ease;
}

.search-section .el-input__inner:focus {
    border-color: #fff;
    background: #fff;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.search-section .el-button--primary {
    background: linear-gradient(135deg, #67c23a, #85ce61);
    border: none;

    font-weight: 600;
    box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
    transition: all 0.3s ease;
}

.search-section .el-button--primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
}

/* 原单信息区域 */
.order-info-section {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    margin-bottom: 5px;
}

.info-header {
    padding: 10px 15px;
}

.info-title {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    display: block;
}

.info-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.info-item {
    font-size: 13px;
    color: #6c757d;
}

/* 响应式布局 */
.content-layout {
    display: flex;
    gap: 5px;
    height: 305px;
}

.content-layout.mobile-layout {
    flex-direction: column;
    height: auto;
    gap: 10px;
}

.products-panel {
    width: 70%;
    display: flex;
    flex-direction: column;
}

.mobile-layout .products-panel {
    flex: none;
}

.operations-panel {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.mobile-layout .operations-panel {
    flex: none;
    gap: 10px;
}

/* 面板头部 */
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;

    border-bottom: none;
}

.panel-title {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
}

.panel-hint {
    font-size: 12px;
    color: #6c757d;
}

/* 选中商品信息区域 */
.selected-product-info {
    border: 1px solid #dee2e6;

    background: #fff;
}

.product-details {
    padding: 12px;
}

.detail-item {
    display: flex;
    margin-bottom: 8px;
    align-items: center;
}

.detail-label {
    font-size: 12px;
    color: #6c757d;
    width: 70px;
    flex-shrink: 0;
}

.detail-value {
    font-size: 13px;
    color: #495057;
    font-weight: 500;
}

/* 数量输入区域 */
.quantity-input-section {
    border: 1px solid #dee2e6;

    background: #fff;
}

.quantity-form {
    padding: 12px;
}

.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    gap: 8px;
}

.form-label {
    font-size: 12px;
    color: #6c757d;
    width: 70px;
    flex-shrink: 0;
}

.max-hint {
    font-size: 11px;
    color: #6c757d;
}

.form-actions {
    text-align: center;
}

/* 操作提示区域 */
.operation-hints {
    padding: 12px;
    font-size: 11px;
}

.hint-title {
    font-weight: 600;
    color: #fff;
    margin-bottom: 8px;
}

.hint-item {
    color: #fff;
    margin-bottom: 4px;
}

/* 退货清单区域 */
.return-cart-section {
    margin-top: 15px;
    border: 1px solid #dee2e6;

    background: #fff;
}

.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: linear-gradient(135deg, #28a745, #34ce57);

    color: #fff;
}

.cart-title-area {
    display: flex;
    align-items: center;
    gap: 8px;
}

.cart-title {
    font-size: 14px;
    font-weight: 600;
}

.cart-count {
    font-size: 12px;
    opacity: 0.9;
}

.cart-hint {
    font-size: 11px;
    opacity: 0.8;
    margin-left: 10px;
}

.cart-summary {
    display: flex;
    gap: 15px;
}

.summary-item {
    font-size: 13px;
}

.amount {
    color: #e74c3c;
    font-weight: 600;
}

/* 底部区域 */
.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 0 0;
    border-top: 1px solid #dee2e6;
}

.footer-summary {
    flex: 1;
}

.footer-info {
    font-size: 13px;
    color: #495057;
}

.footer-buttons {
    display: flex;
    gap: 10px;
}

/* 表格样式 */
:deep(.selected-return-product-row) {
    background-color: #ffdb12 !important;
}

:deep(.selected-return-product-row td) {
    background-color: #ffdb12 !important;
}

:deep(.el-table__row:hover) {
    background-color: #f5f5f5 !important;
}

/* 删除按钮样式 */
.delete-btn {
    color: #e74c3c !important;
}

.delete-btn:hover {
    color: #c0392b !important;
}

/* 移动端样式 */
@media (max-width: 768px) {
    .return-dialog {
        margin: 0 !important;
    }

    .mobile-dialog :deep(.el-dialog) {
        margin: 0 !important;
        max-height: 95vh;
        overflow-y: auto;
    }

    .mobile-dialog :deep(.el-dialog__body) {
        padding: 10px 15px;
    }

    .mobile-info .product-details {
        padding: 8px;
    }

    .mobile-details .detail-item {
        margin-bottom: 6px;
    }

    .mobile-details .detail-label {
        width: 50px;
        font-size: 11px;
    }

    .mobile-details .detail-value {
        font-size: 12px;
    }

    .mobile-quantity .quantity-form {
        padding: 8px;
    }

    .mobile-form .form-row {
        gap: 6px;
    }

    .mobile-row .form-label {
        width: 50px;
        font-size: 11px;
    }

    .mobile-cart .cart-header {
        padding: 8px 12px;
    }

    .mobile-header .cart-title {
        font-size: 13px;
    }

    .mobile-header .cart-count {
        font-size: 11px;
    }

    .mobile-summary {
        flex-direction: column;
        gap: 4px;
        align-items: flex-end;
    }

    .mobile-summary .summary-item {
        font-size: 12px;
    }

    .mobile-footer {
        flex-direction: column;
        gap: 10px;
        align-items: stretch;
    }

    .mobile-buttons {
        justify-content: space-between;
    }

    .panel-hint {
        display: none;
    }
}

@media (max-width: 480px) {
    .return-dialog :deep(.el-dialog) {
        width: 95% !important;
        margin: 2.5% auto !important;
    }

    .search-section {
        padding: 8px 12px;
    }

    .search-section .el-input__inner {
        font-size: 14px;
    }

    .info-content {
        flex-direction: column;
        gap: 8px;
    }

    .info-item {
        font-size: 12px;
    }

    .panel-title {
        font-size: 13px;
    }

    .cart-title {
        font-size: 12px;
    }

    .footer-buttons .el-button {
        flex: 1;
    }
}
</style>
